<template>
  <div>
    <b-card
      no-body
      class="liveinfo-form"
    >
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-form-input
              v-model="query.liveInfoId"
              class="el-def"
              placeholder="ID"
              style="width: 100px;"
            />
            <v-select
              v-model="query.clientId"
              :options="codes.clients"
              placeholder="제약사"
              :reduce="option => option.code"
              class="el-def"
            />
            <b-form-input
              v-model="query.brandName"
              class="el-def"
              placeholder="제품명"
              style="width: 180px;"
            />
            <b-form-input
              v-model="query.liveDiTitle"
              class="el-def"
              placeholder="노출메시지"
              style="width: 180px;"
            />
            <b-form-datepicker
              v-model="query.searchStartDate"
              class="el-def"
              placeholder="노출기간(Fr)"
              style="width:250px;"
            />
            ~
            <b-form-datepicker
              v-model="query.searchEndDate"
              class="el-def"
              placeholder="노출기간(To)"
              style="width:250px;"
            />
            <v-select
              v-model="liveType"
              :options="codes.viewStatusType"
              class="invoice-filter-select el-def"
              :reduce="(option) => option.code"
              placeholder="노출상태"
              style="width:240px;"
            />
            <b-button
              variant="primary"
              class="btn-search"
              @click.prevent="refreshLiveDiList()"
            >
              조회
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-card
      no-body
    >
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start"
          >
            <h5 class="mb-0 ml-50">
              라이브 DI 리스트 [{{ totalRecords }}] 건
            </h5>
          </b-col>
        </b-row>
      </div>
      <b-table
        ref="refLiveDiTable"
        primary-key="id"
        :items="fetchLiveDiList"
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDesc"
        responsive
        sticky-header
        selectable
        select-mode="single"
        class="position-relative"
        @row-selected="onRowSelected"
      >
        <template #cell(liveDiPeriod)="data">
          <span class="text-nowrap">
            {{ data.item.liveDiStartDate | $dateFormatter('YYYY-MM-DD') }} ~ {{ data.item.liveDiEndDate | $dateFormatter('YYYY-MM-DD') }}
          </span>
        </template>
      </b-table>
      <b-row>
        <b-col cols="12">
          <b-pagination
            v-model="currPage"
            :total-rows="totalRecords"
            limit="10"
            per-page="5"
            align="center"
          />
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <b-tabs pills>
        <b-tab
          title="지역·진료과별 통계"
          @click="viewType = 'region-dept'"
        />
        <b-tab
          title="요양기관 리스트"
          @click="viewType = 'hcp'"
        />
      </b-tabs>
    </b-card>
    <b-card>
      <region-dept-view
        v-if="viewType === 'region-dept'"
        :liveinfo-id="selectedLiveInfoId"
        :selected-data="selectedData"
      />
      <hcp-work-place-view
        v-else-if="viewType === 'hcp'"
        :liveinfo-id="selectedLiveInfoId"
        :selected-data="selectedData"
      />
    </b-card>
  </div>
</template>

<script>
import axios from '@axios'
import { onMounted, ref, watch } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import dayjs from 'dayjs'
import vSelect from "vue-select"
import {
  BFormInput, BRow, BCol, BButton,
  BTab, BTabs,
} from 'bootstrap-vue'
import RegionDeptView from './view/RegionDeptView.vue'
import HcpWorkPlaceView from './view/HcpWorkPlaceView.vue'

export default {
  components: {
    vSelect,
    BFormInput,
    BRow,
    BCol,
    BButton,
    BTab,
    BTabs,
    RegionDeptView,
    HcpWorkPlaceView,
  },

  setup() {
    onMounted(() => {
      fetchCodes()
    })
    // Set Codes
    const codes = ref({
      viewStatusType: [],
      clients: [],
    })
    const fetchCodes = () => {
      axios.get("/fa/druglanding/codes")
        .then(rs => {
          const { viewStatusType, clients } = rs.data

          codes.value.viewStatusType = viewStatusType
          codes.value.clients = clients
        })
        .catch(() => {
          pushToast('danger', '코드 데이터를 불러오는데 실패하였습니다.')
        })
    }
    // Set Codes End.

    // Main Table Config
    const refLiveDiTable = ref(null)
    const sortBy = ref('liveInfoId')
    const isSortDesc = ref(true)
    const currPage = ref(1)
    const totalRecords = ref(0)
    const tableColumns = [
      {
        key: 'liveInfoId', label: 'ID', sortable: true, thStyle: { width: '8%' },
      },
      {
        key: 'clientName', label: '제약사명', sortable: true, thStyle: { width: '15%' },
      },
      {
        key: 'brandName', label: '제품명', sortable: true, thStyle: { width: '15%' },
      },
      { key: 'liveDiTitle', label: '라이브 DI 노출메시지', sortable: true },
      {
        key: 'liveDiPeriod', label: '라이브 DI 노출기간', sortable: true, thStyle: { width: '18%' },
      },
      {
        key: 'viewStatus', label: '라이브 DI 노출상태', sortable: true, thStyle: { width: '12%' },
      },
    ]
    const fieldMap = {
      viewStatus: 'ViewStatusCode',
      liveDiPeriod: 'LiveDiStartDate',
    }
    watch([currPage], () => {
      refreshLiveDiList()
    })
    // Main Table Config End.

    const refreshLiveDiList = () => {
      refLiveDiTable.value.refresh()
    }

    const toast = useToast()
    const pushToast = (variant, title) => {
      let icon

      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }

      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }

    const query = ref({
      searchStartDate: null,
      searchEndDate: null,
      clientId: null,
      brandName: null,
      liveDiTitle: null,
      liveInfoId: null,
    })

    const liveType = ref(null)

    const fetchLiveDiList = (ctx, callback) => {
      const frDate = dayjs(query.value.searchStartDate)
      const toDate = dayjs(query.value.searchEndDate)

      // if (!query.value.liveInfoId?.trim()) {
      //   pushToast('warning', 'ID는 필수 검색조건입니다.')
      //   return
      // }
      // // 조회 기간 제한 (해제)
      // if (toDate.diff(frDate, 'day') > 90) {
      //   pushToast('warning', '조회 기간은 최대 90일을 넘을 수 없습니다.')
      //   return
      // }

      // 종료일이 시작일보다 빠를 수 없음
      if (toDate.diff(frDate, 'day') < 0) {
        pushToast('warning', '종료일이 시작일보다 앞설 수 없습니다.')
        callback([])
        return
      }

      axios.post(`/fa/druginfo/quick-search/live-di`, {
        search: {
          query: query.value,
          liveType: liveType.value,
          isIncludeAll: true,
        },
        sort: {
          predicate: fieldMap[sortBy.value] || sortBy.value,
          reverse: isSortDesc.value,
        },
        pagination: {
          number: currPage.value,
          count: 5,
        },
      })
        .then(rs => {
          const { items, totalRecord } = rs.data
          callback(items)
          totalRecords.value = totalRecord
        })
        .catch(err => {
          pushToast('danger', `데이터 조회 중 오류가 발생하였습니다.${err}`)
        })
    }

    const selectedLiveInfoId = ref(null)
    const selectedData = ref(null)

    const onRowSelected = items => {
      selectedLiveInfoId.value = items[0]?.liveInfoId ?? null
      selectedData.value = items[0] ?? null
    }

    const viewType = ref("region-dept")

    return {
      codes,
      fetchCodes,
      query,
      liveType,
      fetchLiveDiList,
      sortBy,
      isSortDesc,
      currPage,
      tableColumns,
      totalRecords,
      onRowSelected,
      refLiveDiTable,
      refreshLiveDiList,
      viewType,
      selectedLiveInfoId,
      selectedData,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.dropdown-menu {
  z-index: 100 !important;
}
</style>
